import { Grid, Stack, Typography } from "@mui/material";
import BusinessEntityLinkContainer from "./BusinessEntityLink";

export default function BusinessEntityList({
  inline,
  entityIds,
}: {
  inline?: boolean;
  entityIds?: string[] | null;
}) {
  return inline ? (
    entityIds?.length ? (
      <Stack direction="row" spacing={1}>
        {entityIds.map((entityId) => (
          <BusinessEntityLinkContainer key={entityId} entityId={entityId} />
        ))}
      </Stack>
    ) : (
      <Typography variant="body2">N/A</Typography>
    )
  ) : (
    <Grid container direction="row" spacing={1}>
      {entityIds?.length ? (
        entityIds.map((entityId) => (
          <Grid item key={entityId}>
            <BusinessEntityLinkContainer entityId={entityId} />
          </Grid>
        ))
      ) : (
        <Typography variant="body2">N/A</Typography>
      )}
    </Grid>
  );
}
